export class AppMeta {
    public minimumSupportedVersion: AppVersion;
    public currentVersion: AppVersionByPlatform;
    public featureFlags: {
        backgroundGeolocation: boolean;
    };

    constructor(initialValues?: Partial<AppMeta>) {
        this.minimumSupportedVersion = initialValues?.minimumSupportedVersion ?? DEFAULT_VERSION;
        this.currentVersion = {
            android: initialValues?.currentVersion?.android ?? DEFAULT_VERSION,
            ios: initialValues?.currentVersion?.ios ?? DEFAULT_VERSION,
            web: initialValues?.currentVersion?.web ?? DEFAULT_VERSION,
        };
        this.featureFlags = {
            backgroundGeolocation: initialValues?.featureFlags?.backgroundGeolocation ?? true,
        };
    }
}

export interface AppVersion {
    major: number;
    minor: number;
    patch: number;
}

export interface AppVersionByPlatform {
    android: AppVersion;
    ios: AppVersion;
    web: AppVersion;
}

const DEFAULT_VERSION: AppVersion = { major: 0, minor: 0, patch: 0 };
